<template>
  <div class="flex">
    <el-select
      v-if="showCountry"
      v-model="countryValue"
      placeholder="请选择国家"
      class="country-item"
      @change="handleCountryChange"
    >
      <el-option
        v-for="item in countryOptions"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      />
    </el-select>

    <div class="area-item">
      <el-input
        v-if="showForeignInput"
        v-model.trim="foreignAddress"
        placeholder="请输入国家名称"
        v-bind="$attrs"
        @blur="handleForeignAddress"
      />

      <el-cascader
        v-else
        v-model="areaValue"
        :options="areaOptions"
        placeholder="请选择地区"
        clearable
        @change="handleAreaChange"
      />
    </div>
  </div>
</template>

<script>
import area from '@/dictionary/area/area'
import { cloneDeep } from 'lodash'

export default {
  name: 'BaseAreaCascader',

  props: {
    // 地址，请按照如下格式传入
    address: {
      type: Object,
      default: () => {
        return {
          country: '中国',
          province: '',
          city: '',
          county: '',
          foreign: ''
        }
      }
    },

    // 选择区域范围
    addressRange: {
      type: String,
      default: 'county'
    },

    // 是否显示国家
    showCountry: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      countryOptions: [
        { label: '中国', value: '中国' },
        { label: '国外', value: '国外' }
      ],

      countryValue: '中国',
      areaValue: [],
      foreignAddress: ''
    }
  },

  computed: {
    showForeignInput() {
      return this.countryValue !== '中国'
    },

    areaOptions() {
      const tempArray = cloneDeep(area)
      if (this.addressRange === 'city') {
        tempArray.forEach(item => {
          item.children.forEach(child => {
            delete child.children
          })
        })
      }
      return tempArray
    }
  },

  watch: {
    address(newVal) {
      this.setAddressBack(newVal)
    }
  },

  created() {
    // if (this.addressRange === 'city') {
    //   this.areaOptions = cityArea
    // }
    // console.log('log address', this.address)
    this.setAddressBack(this.address)
  },

  methods: {
    setAddressBack(address) {
      // console.log('log address', address)
      if (
        this.showCountry &&
        address.country !== '中国' &&
        address.country !== '' &&
        address.country !== null
      ) {
        this.countryValue = '国外'
        this.foreignAddress = address.foreign === '国外' ? '' : address.foreign
      } else {
        this.areaValue =
          this.addressRange === 'city'
            ? [address.province, address.city]
            : [address.province, address.city, address.county]
      }
    },

    handleAreaChange() {
      this.foreignAddress = ''
      const tempObj =
        this.addressRange === 'city'
          ? {
            country: this.countryValue,
            province: this.areaValue[0],
            city: this.areaValue[1],
            foreign: this.foreignAddress
          }
          : {
            country: this.countryValue,
            province: this.areaValue[0],
            city: this.areaValue[1],
            county: this.areaValue[2],
            foreign: this.foreignAddress
          }
      this.$emit('update:address', tempObj)
    },

    handleCountryChange() {
      this.areaValue = []
      this.foreignAddress = ''
      const tempObj =
        this.addressRange === 'city'
          ? {
            country: this.countryValue,
            province: '',
            city: '',
            foreign: ''
          }
          : {
            country: this.countryValue,
            province: '',
            city: '',
            county: '',
            foreign: ''
          }
      this.$emit('update:address', tempObj)
    },

    handleForeignAddress() {
      // console.log('log foreign address', this.foreignAddress)
      const tempObj =
        this.addressRange === 'city'
          ? {
            country: this.countryValue,
            province: '',
            city: '',
            foreign: this.foreignAddress
          }
          : {
            country: this.countryValue,
            province: '',
            city: '',
            county: '',
            foreign: this.foreignAddress
          }
      this.$emit('update:address', tempObj)
    }
  }
}
</script>

<style lang="scss" scoped>
.country-item {
  margin-right: pixel-to-rem($n: 20);
  width: 20%;
}

.area-item {
  flex: 1;

  ::v-deep .el-cascader {
    width: 100%;
  }
}
</style>
